import { getFocusableElements } from '../helpers.js'

const navDropdownToggles = document.querySelectorAll('[data-nav-dropdown]')
let elOpenedDropdownButton
let focusableElements

/**
 * Open a dropdown by updating its toggle's state
 * @param el {HTMLElement}
 */
const openDropdown = (el) => {
    elOpenedDropdownButton = el
    const elDropdown = el.closest('li').querySelector('.navigationDropdown')
    el.setAttribute('data-dropdown-state', 'open')
    el.setAttribute('aria-expanded', 'true')
    elDropdown.setAttribute('aria-hidden', 'false')
    focusableElements = getFocusableElements(elDropdown)
    const [finalFocusableElement] = focusableElements.reverse()

    // Close on dropdowns on escape key press
    document.addEventListener('keyup', handleEscape)

    // Close dropdown when clicked outside
    document.addEventListener('click', handleClickaway)

    // Close dropdown when user tabs away from last link
    finalFocusableElement.addEventListener('keydown', (event) => {
        if (event.keyCode === 9 && !event.shiftKey) {
            closeDropdowns()
        }
    })
}

/**
 * Closes all dropdown and can optionally set focus back to the toggle
 * @param setFocus {boolean}
 */
const closeDropdowns = (setFocus = false) => {
    Array.from(navDropdownToggles).forEach((elToggle) => {
        elToggle.setAttribute('data-dropdown-state', 'closed')
        elToggle.setAttribute('aria-expanded', 'false')
        elToggle
            .closest('li')
            .querySelector('.navigationDropdown')
            .setAttribute('aria-hidden', 'true')

        document.removeEventListener('keyup', handleEscape)
        document.removeEventListener('click', handleClickaway)

        if (elOpenedDropdownButton && setFocus) {
            elOpenedDropdownButton.focus()
        }
    })
}

/**
 * Handle closing dropdowns when clicked outside
 * @param evt {Event}
 */
const handleClickaway = (evt) => {
    if (evt.target.closest('.siteHeader__navItem')) {
        return
    }

    closeDropdowns()
}

/**
 * Handle closing dropdowns when escape is pressed
 * @param evt {Event}
 */
const handleEscape = (evt) => {
    if (evt.keyCode === 27) closeDropdowns(true)
}

Array.from(navDropdownToggles).forEach((elToggle) => {
    elToggle.addEventListener('click', function () {
        if (this.getAttribute('data-dropdown-state') === 'closed') {
            closeDropdowns()
            openDropdown(this)
            return
        }

        closeDropdowns(true)
    })
})
